import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Mode } from '../../constants/enums';

const useStyles = makeStyles((theme: Theme) => ({
  contactName: {
    fontWeight: 600,
    textTransform: 'capitalize',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    fontWeight: 800,
    fontSize: '20px',
    '& img': { width: '40px' },
    color: theme.palette.secondary.contrastText,
  },
  appBar: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    display: 'flex',
    padding: '20px',
    position: 'relative !important' as 'relative',
    boxSizing: 'border-box !important' as 'border-box',
    alignItems: 'center',
    flexDirection: 'row !important' as 'row',
    justifyContent: 'space-between',
    '& svg': {
      cursor: 'pointer',
      width: '25px',
      height: '25px',
      '& path': {
        fill: theme.palette.secondary.contrastText,
        stroke: theme.palette.secondary.contrastText,
      },
    },
  },
  contentWrapper: { display: 'grid', background: '#a2a2a22e' },
  sideBarItem: {
    display: 'flex',
    gap: '0',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    cursor: 'pointer',
    borderRadius: '10px',
    '& svg': {
      width: '40px',
      height: '40px',
      '& path': { fill: theme.palette.mode === Mode.Dark ? 'white' : undefined },
    },
    transition: '0.25s background',
    '&:hover': {
      background: 'var(--color-primary)',
      color: theme.palette.secondary.contrastText,
      '& svg': { '& path': { fill: theme.palette.secondary.contrastText } },
    },
  },
  sideBarItemActive: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: theme.palette.secondary.contrastText,
    '& svg': { '& path': { fill: theme.palette.secondary.contrastText } },
  },
  sideBar: {
    '& div': {
      position: 'relative !important',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      padding: '10px 5px 10px 5px',
      boxSizing: 'border-box',
      backgroundColor:
        theme.palette.mode === Mode.Light ? theme.palette.common.white : theme.palette.common.black,
    },
  },
  notificationItem: {
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    cursor: 'pointer',
    '& svg': {
      minWidth: '25px',
      minHeight: '25px',
      width: '25px',
      height: '25px',
      '& path': { fill: '#646464' },
    },
  },
  notificationsList: {
    display: 'flex',
    gap: '5px',
    padding: '5px 20px',
    boxSizing: 'border-box',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  notificationMenuText: {
    width: '100%',
    height: 'inherit',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'inherit',
    maxHeight: 'inherit',
  },
  notificationMenu: {
    '& ul': { padding: '0' },
  },
  technicianDataField: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  loader: {
    color: 'white !important',
    width: 'unset !important',
    height: 'unset !important',
  },
  dialogButton: {
    margin: '15px 0px',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  margin5: {
    margin: '5px',
  },
  name: {
    color: theme.palette.secondary.contrastText,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  mainContent: {
    overflowY: 'scroll',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  noLayoutWrapper: {
    width: '100%',
    height: '100%',
    background: theme.palette.background.default,
  },
  techVerificationButton: {
    fontSize: 'small',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'row',
    gap: '2px',
    alignItems: 'center',
    cursor: 'pointer',
    border: '1px solid var(--color-primary)',
    padding: '5px 10px',
    boxSizing: 'border-box',
    color: 'var(--color-primary)',
    '& svg': {
      width: '25px',
      height: '25px',
      fill: 'var(--color-primary)',
    },
  },
  processingCircle: {
    color: 'var(--color-primary)',
    width: '25px !important',
    height: '25px !important',
    '& svg': { width: '25px', height: '25px' },
  },
  techName: {
    margin: '10px 0',
  },
  code: {
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 600,
  },
}));

export default useStyles;
